<template>
  <div class="send-message position-absolute p-3 border-top w-100 d-flex flex-row bg-white">
    <b-form-group class="flex-grow-1 mb-0">
      <b-form-input
        id="send-message-field"
        class="border-0 rounded-0"
        placeholder="Type your message..."
        :disabled="!selectedOrder || loading.send_message"
        v-model="message_field">
      </b-form-input>
    </b-form-group>
    <b-button
      id="send-message-button"
      class="ml-3 p-0 bg-transparent border-0 shadow-none"
      :disabled="!selectedOrder || loading.send_message || !message_field"
      @click="sendMessage">
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapGetters({
      loading: "conversationalCommerce/loading",
      selectedOrder: "conversationalCommerce/selectedOrder"
    }),
    ...mapFields("conversationalCommerce", ["message_field"])
  },
  methods: {
    sendMessage() {
      this.$store.dispatch("conversationalCommerce/sendMessage");
    }
  }
}
</script>

<style lang="scss" scoped>
.send-message {
  bottom: 0;
  #send-message-field {
    font-size: 16px;
    color: #2F3941;
    &:disabled {
      background-color: transparent;
    }
    &::placeholder {
      color: #68737D;
    }
  }
  #send-message-button {
    width: 40px;
    height: 40px;
    background: url('~@/assets/images/icons/send-message.svg');
  }
}
</style>
